import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
const STATUS_COLOR = {
    success: 'var(--success)',
    warning: 'var(--warning)',
    critical: 'var(--critical)',
    muted: 'var(--text-muted)',
};
let uniqueIdCounter = 0;
function nextUniqueId() {
    uniqueIdCounter += 1;
    return `settings-card-${uniqueIdCounter}`;
}
export function SettingsCard(props) {
    const { title, status, statusTone = 'muted', action, description, ariaLabel, as: Root = 'section', children, } = props;
    const titleIdRef = React.useRef(null);
    if (titleIdRef.current === null)
        titleIdRef.current = nextUniqueId();
    const showHeader = title != null || status != null || action != null;
    const ariaProps = title != null
        ? { 'aria-labelledby': titleIdRef.current }
        : ariaLabel
            ? { 'aria-label': ariaLabel }
            : {};
    return (_jsxs(Root, { ...ariaProps, style: {
            border: '1px solid var(--border)',
            borderRadius: 'var(--radius-card, 0.5rem)',
            padding: 'var(--space-4, 1.25rem) var(--space-5, 1.5rem)',
            background: 'var(--surface)',
            display: 'flex',
            flexDirection: 'column',
            gap: 'var(--space-3, 0.75rem)',
        }, children: [showHeader ? (_jsxs("header", { style: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'baseline',
                    gap: 'var(--space-3, 0.75rem)',
                    flexWrap: 'wrap',
                }, children: [title != null ? (_jsx("h2", { id: titleIdRef.current, style: {
                            margin: 0,
                            fontSize: 'var(--font-size-lg, 1.15rem)',
                            fontWeight: 600,
                            color: 'var(--text)',
                        }, children: title })) : (_jsx("span", { "aria-hidden": true })), _jsxs("div", { style: {
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: 'var(--space-3, 0.75rem)',
                        }, children: [status != null ? (_jsx("span", { style: {
                                    fontSize: 'var(--font-size-xs, 0.75rem)',
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.05em',
                                    color: STATUS_COLOR[statusTone],
                                    fontWeight: 600,
                                }, children: status })) : null, action] })] })) : null, description != null ? (_jsx("p", { style: { margin: 0, color: 'var(--text-muted)', fontSize: 'var(--font-size-sm, 0.9rem)' }, children: description })) : null, children] }));
}
//# sourceMappingURL=SettingsCard.js.map